import { normalizeSaisie } from '../normalizers/normalizeSaisie';
import PrintEnonce from '../helpers/PrintEnonce';
import { consignePour } from '../helpers/saisiePolicy';

/**
 * Renderer print d'une saisie libre (type 'texte').
 *
 * `saisieMode` (global document) :
 *   - 'sur_la_feuille' → consigne + lignes pointillées + suffixe éventuel
 *   - 'sur_le_cahier'  → consigne « Réponds sur ton cahier. », pas de lignes
 */
/**
 * Corps d'une saisie (lignes pointillées + suffixe), sans header ni consigne
 * ni énoncé. Partagé par le single et les blocs à figure partagée.
 * Réponse courte connue (nombre ou mot ≤ 10 chars) → 1 ligne compacte,
 * sinon → 3 lignes (rédaction ou ouverte). Rien en mode cahier.
 */
export const SaisieBody = ({ correctAnswer, suffixe, saisieMode = 'sur_la_feuille' }) => {
    if (saisieMode === 'sur_le_cahier') return null;
    const isShortAnswer = correctAnswer != null && correctAnswer.length <= 10;
    return isShortAnswer ? (
        <div className="ep-answer-lines ep-answer-lines-short">
            <div className="ep-answer-line">
                {suffixe && <span className="ep-saisie-suffixe">{suffixe}</span>}
            </div>
        </div>
    ) : (
        <div className="ep-answer-lines">
            <div className="ep-answer-line">
                {suffixe && <span className="ep-saisie-suffixe">{suffixe}</span>}
            </div>
            <div className="ep-answer-line" />
            <div className="ep-answer-line" />
        </div>
    );
};

const PrintSaisie = ({ payload, num, saisieMode = 'sur_la_feuille' }) => {
    const { question, correctAnswer, suffixe } = normalizeSaisie(payload, num);

    return (
        <div className="ep-exo">
            <span className="ep-exo-num">{num}</span>
            <p className="ep-exo-consigne">{consignePour(payload, saisieMode)}</p>
            <PrintEnonce texte={question} elements={payload?.elements_additionnels?.elements} />
            <SaisieBody correctAnswer={correctAnswer} suffixe={suffixe} saisieMode={saisieMode} />
        </div>
    );
};

export default PrintSaisie;
